import styled from 'styled-components';
import { MIN_LAYOUT_WIDTH } from '../styles/constants';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;

  @media print {
    display: block;
    overflow-y: scroll;
    overflow-x: hidden;
    height: auto;
  }
`;

export const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  overflow: hidden;

  @media print {
    // allow pagination when printing
    overflow-y: scroll;
    overflow-x: hidden;
  }
`;

export const LayoutMainContainer = styled.main.attrs(() => ({
  id: 'main-container',
}))`
  position: relative;
  flex: 1;
  padding: 16px;
  min-width: ${MIN_LAYOUT_WIDTH}px;
`;
